import { useQuery } from '@tanstack/react-query';
import { Avatar, Box, LinearProgress, List, ListItem, Paper, Stack, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { getCounselorRanking } from '../../api/dashboard';
import { useBranchFilter } from '../../context/branchContext';
import { EmptyState } from '../../components/EmptyState';

const MEDAL_COLORS = ['#D4AF37', '#A8A9AD', '#AD8A56'];

export const CounselorLeaderboardCard = () => {
  const { selectedBranchId } = useBranchFilter();
  // Dashboard Counselor-sections inactive-employee exclusion — inactive
  // employees must not appear, be ranked, or factor into the max-assigned
  // scale the progress bars below are relative to.
  const rankingQuery = useQuery({
    queryKey: ['counselor-ranking', 'active-only', selectedBranchId],
    queryFn: () => getCounselorRanking(true, selectedBranchId),
  });
  const ranking = rankingQuery.data ?? [];
  const maxAssigned = Math.max(...ranking.map((r) => r.leadsAssigned), 1);

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Counselor leaderboard
      </Typography>
      {ranking.length === 0 ? (
        <EmptyState loading={rankingQuery.isLoading} message="No leads have been assigned yet" />
      ) : (
        <List dense disablePadding>
          {ranking.slice(0, 6).map((entry, index) => (
            <ListItem key={entry.id} disableGutters sx={{ py: 1 }}>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ width: '100%' }}>
                {index < 3 ? (
                  <EmojiEventsIcon sx={{ color: MEDAL_COLORS[index] }} />
                ) : (
                  <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: 'action.hover', color: 'text.secondary' }}>
                    {index + 1}
                  </Avatar>
                )}
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
                      {entry.firstName} {entry.lastName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {entry.leadsConverted}/{entry.leadsAssigned} · {entry.conversionRate}%
                    </Typography>
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    value={(entry.leadsAssigned / maxAssigned) * 100}
                    sx={{ height: 6, borderRadius: 3, mt: 0.5 }}
                  />
                  <Typography variant="caption" color="text.secondary">
                    {entry.followUpsToday} today · {entry.pendingFollowUps} pending · {entry.lostLeads} lost
                  </Typography>
                </Box>
              </Stack>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};
